import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import './css/navbar.css';
import DropdownNavBar from './DropdownNavBar';
import MenuBar from './MenuBar';

class NavBar extends Component {
 
  render() {
    return (
      <div className="navbar-own">
          <button style={{padding: '5px',border: 'none', backgroundColor: 'lightgrey',color: 'grey', fontSize: '0.8em' }} onClick={this.props.onLogout}>Logout</button>
      </div>
    )
  }
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/HomeComponents/HeaderComponents/Navbar.jsx